var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container approveDetail_reportItem" },
    [
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.historyBack } },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
          _vm.feedbackReport.canAudit
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Feedback - _vm.reportsAudit,
                      expression: "Feedback-reportsAudit",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.audit("PASS")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.ApprovalPass")))]
              )
            : _vm._e(),
          _vm.feedbackReport.canAudit
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Feedback - _vm.reportsAudit,
                      expression: "Feedback-reportsAudit",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.audit("REJECT")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.ApprovalReject")))]
              )
            : _vm._e(),
          _vm.feedbackReport.canSendCQS
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Feedback - _vm.reportsAudit,
                      expression: "Feedback-reportsAudit",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.audit("UNJUDGEABLE")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("storeFeedback.report.sendCQS")))]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "reportForm",
          attrs: {
            model: _vm.feedbackReport,
            "label-position": "right",
            inline: "",
            "label-width": "220px",
            rules: _vm.feedbackReportRules,
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "reportFormTop" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.feedbackNo"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.feedbackHead.feedbackNo,
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.reportNo"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.feedbackReport.reportNo,
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.reportType"),
                            prop: "reportType",
                          },
                        },
                        [
                          _c("IcSelect", {
                            attrs: {
                              table: "TT_FEEDBACK_REPORT",
                              field: "REPORT_TYPE",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.reportType,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "reportType", $$v)
                              },
                              expression: "feedbackReport.reportType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.supplierCostTime"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: (
                                _vm.feedbackHead.supplierCostTime / 60
                              ).toFixed(2),
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.remark"),
                            prop: "reportRemark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                              maxlength: "200",
                            },
                            model: {
                              value: _vm.feedbackReport.reportRemark,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "reportRemark",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.reportRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("storeFeedback.report.basicInfo"))),
                  ]),
                ]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.receiveDate"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm._f("dateFormatFilter")(
                                _vm.feedbackReport.receiveDate,
                                "YYYY-MM-DD"
                              ),
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "widthReset",
                          attrs: {
                            label: _vm.$t("storeFeedback.report.problemLevel"),
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              clearable: "",
                              table: "TT_FEEDBACK_FIRST_CHECK",
                              field: "PROBLEM_LEVEL",
                              disabled: !_vm.feedbackReport.canAudit,
                            },
                            model: {
                              value: _vm.feedbackReport.feedbackLevel,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "feedbackLevel",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.feedbackLevel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      !_vm.isStore
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.report.deadline"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm._f("dateFormatFilter")(
                                    _vm.feedbackReport.reportDeadline,
                                    "YYYY-MM-DD HH:mm:ss"
                                  ),
                                  disabled: "",
                                  clearable: "",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      !_vm.isStore
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "storeFeedback.report.haveRejected"
                                ),
                              },
                            },
                            [
                              _vm.feedbackReport.haveRejectedByCqs
                                ? _c("el-input", {
                                    attrs: {
                                      value: _vm._f("ic")(
                                        _vm.feedbackReport.haveRejectedByCqs,
                                        "COMMON",
                                        "YES_NO"
                                      ),
                                      disabled: "",
                                      clearable: "",
                                    },
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      value: "否",
                                      disabled: "",
                                      clearable: "",
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.canContinue"),
                            prop: "canContinue",
                          },
                        },
                        [
                          _c("IcSelect", {
                            attrs: {
                              table: "COMMON",
                              field: "YES_NO",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canAudit,
                            },
                            model: {
                              value: _vm.feedbackReport.canContinue,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "canContinue", $$v)
                              },
                              expression: "feedbackReport.canContinue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "storeFeedback.report.sampleHandleMethod"
                            ),
                            prop: "sampleHandleMethod",
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              table: "TT_FEEDBACK_REPORT",
                              field: "SAMPLE_HANDLE_METHOD",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.sampleHandleMethod,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "sampleHandleMethod",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.sampleHandleMethod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.feedbackReport.canAudit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "storeFeedback.report.responsibleParty"
                                ),
                                prop: "responsibleParty",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  "table-fields": _vm.responsiblePartyField,
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.feedbackReport.responsibleParty,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "responsibleParty",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.responsibleParty",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "storeFeedback.report.responsibleParty"
                                ),
                                prop: "responsibleParty",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  "table-fields": _vm.responsiblePartyField,
                                  clearable: "",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.feedbackReport.responsibleParty,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "responsibleParty",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.responsibleParty",
                                },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.needDebit"),
                            prop: "needDebit",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: !_vm.feedbackReport.canAudit,
                              },
                              on: { change: _vm.needDebitChange },
                              model: {
                                value: _vm.feedbackReport.needDebit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.feedbackReport, "needDebit", $$v)
                                },
                                expression: "feedbackReport.needDebit",
                              },
                            },
                            [
                              _c(
                                "el-option",
                                { attrs: { value: "Y", label: "是" } },
                                [_vm._v("是")]
                              ),
                              _c(
                                "el-option",
                                { attrs: { value: "N", label: "否" } },
                                [_vm._v("否")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.debitNumber"),
                            prop: "debitNumber",
                            rules: _vm.isneedDebit
                              ? _vm.feedbackReportRules.debitNumber
                              : _vm.feedbackReportRules.debitNumber2,
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              onkeyup:
                                "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
                              clearable: "",
                              disabled:
                                !_vm.feedbackReport.canAudit ||
                                !_vm.isneedDebit,
                              maxLength: "9",
                            },
                            model: {
                              value: _vm.feedbackReport.debitNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "debitNumber", $$v)
                              },
                              expression: "feedbackReport.debitNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeFeedback.report.debitUnit"),
                        prop: "debitUnit",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", disabled: true },
                        model: {
                          value: _vm.feedbackReport.debitUnitI18n,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackReport, "debitUnitI18n", $$v)
                          },
                          expression: "feedbackReport.debitUnitI18n",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "autoWidth" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("storeFeedback.report.reportDetail"))),
                  ]),
                ]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                            prop: "reportDetail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.reportDetail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "reportDetail",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.reportDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.DocAttachment"),
                            prop: "reportDetailDoc",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "tableFile",
                              attrs: {
                                data: _vm.feedbackReport.reportDetailDoc,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.value.canEdit
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "tmDocumentId",
                                      "min-width": "130px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.deleteFile(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.feedbackReport
                                                          .reportDetailDoc
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("common.del"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1750758934
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.feedbackReport.canEdit
                            ? _c(
                                "el-upload",
                                {
                                  ref: "reportDetailDoc",
                                  attrs: {
                                    disabled: "",
                                    action: "upload",
                                    "http-request": _vm.reportDetailDocUpload,
                                    multiple: "",
                                    "on-remove": _vm.reportDetailDocRemove,
                                    "show-file-list": "false",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.PicAttachment"),
                          },
                        },
                        [
                          _c("el-upload", {
                            staticClass: "hideView",
                            attrs: {
                              "on-preview": _vm.reportDetailImgPreview,
                              disabled: "",
                              "list-type": "picture-card",
                              action: "upload",
                              "file-list": _vm.reportDetailImg,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "file",
                                fn: function ({ file }) {
                                  return _c(
                                    "div",
                                    {},
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "", disabled: "" },
                                        model: {
                                          value: file.docComments,
                                          callback: function ($$v) {
                                            _vm.$set(file, "docComments", $$v)
                                          },
                                          expression: "file.docComments",
                                        },
                                      }),
                                      _c("img", {
                                        staticClass:
                                          "el-upload-list__item-thumbnail",
                                        attrs: { src: file.url, alt: "" },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.reportDetailImgPreview(
                                                    file
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-zoom-in",
                                              }),
                                            ]
                                          ),
                                          file.tmDocumentId
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "el-upload-list__item-delete",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.downloadFile(
                                                        file
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-download",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                },
                              },
                            ]),
                          }),
                          _c(
                            "el-dialog",
                            {
                              staticClass: "enlargePhoto",
                              attrs: { visible: _vm.dialogVisible },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.dialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.dialogImageUrl,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "autoWidth" },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("storeFeedback.report.treatment"))),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.treatment,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "treatment", $$v)
                              },
                              expression: "feedbackReport.treatment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.attachment"),
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "tableFile",
                              attrs: {
                                data: _vm.feedbackReport.treatmentDoc,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.value.canEdit
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "tmDocumentId",
                                      "min-width": "130px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.deleteFile(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.feedbackReport
                                                          .treatmentDoc
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("common.del"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1504342029
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.feedbackReport.canEdit
                            ? _c(
                                "el-upload",
                                {
                                  ref: "treatmentDoc",
                                  attrs: {
                                    action: "upload",
                                    "http-request": _vm.treatmentDocUpload,
                                    multiple: "",
                                    "on-remove": _vm.treatmentDocRemove,
                                    "show-file-list": "false",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "autoWidth" },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("storeFeedback.report.supplierAnalysis"))
                  ),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                            prop: "supplierAnalysis",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.supplierAnalysis,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "supplierAnalysis",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.supplierAnalysis",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "autoWidth" },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("storeFeedback.report.CQSAnalysis"))),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                            prop: "cqsAnalysis",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              row: "3",
                              autosize: "",
                              disabled: !_vm.feedbackReport.canAudit,
                              clearable: "",
                              maxlength: "1000",
                            },
                            model: {
                              value: _vm.feedbackReport.cqsAnalysis,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "cqsAnalysis", $$v)
                              },
                              expression: "feedbackReport.cqsAnalysis",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "popclass",
          attrs: {
            title: _vm.approveTitle,
            visible: _vm.approveDialog,
            width: "46%",
            "before-close": _vm.cancelapproveDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.approveDialog = $event
            },
          },
        },
        [
          _vm.isPASS
            ? _c("el-row", [
                _c("p", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    "请确认是否需要对投诉分类及等级进行调整？如需调整，点击取消按钮；无需调整，请直接审批通过即可。"
                  ),
                ]),
              ])
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "approveForm",
              attrs: { model: _vm.approveForm, rules: _vm.approveRules },
            },
            [
              _vm.isPASS
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.remarks") } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", maxlength: "300" },
                        model: {
                          value: _vm.approveForm.auditRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.approveForm, "auditRemark", $$v)
                          },
                          expression: "approveForm.auditRemark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isSendCqs && _vm.isFBC
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.remarks"),
                        prop: "sendCqsRemark",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", maxlength: "300" },
                        model: {
                          value: _vm.approveForm.sendCqsRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.approveForm, "sendCqsRemark", $$v)
                          },
                          expression: "approveForm.sendCqsRemark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isREJECT
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeFeedback.report.pleaseFillInRejectReason"
                        ),
                        prop: "RejectReason",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", maxlength: "300" },
                        model: {
                          value: _vm.approveForm.RejectReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.approveForm, "RejectReason", $$v)
                          },
                          expression: "approveForm.RejectReason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModifyReason
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeFeedback.report.ModifyReason"),
                        prop: "ModifyReason",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", maxlength: "300" },
                        model: {
                          value: _vm.approveForm.ModifyReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.approveForm, "ModifyReason", $$v)
                          },
                          expression: "approveForm.ModifyReason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.cancelapproveDialog },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approveConfirm("approveForm")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }